<template>
  <div class="container">
        <div class="wrap">
            <pageHeader/>
            <pageBack/>
            <PoseDetectionComponent  @updateState="handleChildData"/>
            <div class="mask">
                <div class="step">
                    <p class="on">1</p>
                    <span :class="{'on':status==2}"></span>
                    <p :class="{'on':status==2}">2</p>
                </div>
                <div class="font80">{{stepTitle}}</div>
                <div class="font40">{{stepInfo}}</div>
                 <!-- 文件选择框 -->
                <!-- <input type="file" @change="handleFileChange" accept="image/*" />
                <button @click="uploadImage" class="alert">上传图片</button> -->
                <!-- <div class="img-box">
                    <img :src="frontImg" alt="" srcset="">
                    <img :src="sideImg" alt="" srcset="">
                </div> -->
                <img :src="imgUrl" alt="" srcset="" class="img">
            </div>
            <pagePop status='dimension' v-if="showLoad" @goBack="goBack()"/>
        </div>
        <!-- <van-dialog
                title="标题"
                message="弹窗内容"
                :show="show"
                custom-class="my-custom-class"
                /> -->
    </div>
</template>
<script>
import PoseDetectionComponent from '../../components/poseDetection.vue'
import pagePop from '../../components/popup.vue'
import axios from 'axios';
import { addFitter } from "../../api/user.js";
import { Toast, Dialog} from 'vant';
import { Howl } from 'howler';
import { getInfo } from '@/api/user';
// import Dialog from '@vant/weapp/dialog/dialog';
export default {
    name:'aiFitter',
    components: {
        pagePop,
        PoseDetectionComponent
    },
    data() {
        return {
            stepTitle:'第一步：正面照',
            stepInfo:'双脚打开与肩同宽，双臂自然那打开与身体呈45度',
            status:1,
            mask1:require('@/assets/ai/mask1.png'),
            mask2:require('@/assets/ai/mask2.png'),
            imgUrl:require('@/assets/ai/mask1.png'),
            sideImg:'',//侧面照片
            frontImg:'',//正面照片
            imageUrl:'',
            audio1:'',
            audio2:'',
            audio3:'',
            audio4:'',
            selectedFile:'',
            data:{
                img1:'',
                img2:'',
                id:localStorage.getItem('taskId')
            },
            showLoad:false,
            timer:null,
            isCompleted:false,
            show:true
        }
    },
    methods: {
        handleChildData(data) {
            // 接收子组件传递的数据
            console.log(data)
            if(data.type == 'front'){
                this.stepTitle='第二步：侧面照'
                this.stepInfo=''
                this.status = 2
                this.imgUrl = this.mask2
                this.frontImg = data.imgUrl
                this.data.img1 = data.imgUrl
                 this.audio1.pause(); // 暂停音频
                 this.audio2.play();
                //  setTimeout(() => {
                //     this.audio3.play()
                //  }, 3000);
            }else if(data.type == 'side'){
                this.sideImg = data.imgUrl
                this.data.img2 = data.imgUrl;
                this.audio2.pause(); // ���停音频
                this.audio4.play();
                
                // setTimeout(() => {
                //     this.$router.push({ name: 'videoLoad',params:{status:'dimension'} });
                // }, 3000);
                // alert('侧面照片上传成功')
                // this.$router.push({ name: 'videoLoad',params:{status:'dimension'} });
                setTimeout(() => {
                    this.showLoad = true
                    addFitter(this.data).then((res) => {
                        console.log('添加数据成功', res)
                        if(res.code==1){
                            localStorage.setItem('aiData', JSON.stringify(this.data))
                            // setTimeout(() => {
                            //     this.$router.push({ name: 'videoLoad',params:{status:'dimension'} });
                                
                            // }, 1000);
                            this.timer = setInterval(() => {
                                this.getInfo()
                            }, 2000);
                        }else{
                            Toast(res.msg)
                        }
                    })
                    
                }, 3000);
                // this.audio3.pause()
                // this.audio4.play()
            }
        },
        getInfo(){
            getInfo({id:localStorage.getItem('taskId')}).then((res) => {
                if (res.code === 1) {
                    let status = res.data.status;
                    this.isCompleted = res.data.status == 2? true : false;
                    if(status == 2){
                        clearInterval(this.timer)
                        this.$router.push({ path: '/myDimension'})
                    }else if(status == -1){
                        clearInterval(this.timer)
                        Toast('数据识别失败,请重试！');
                        setTimeout(() => {
                            this.$router.go(0);
                        }, 1000);
                    }
                    // if(this.isCompleted){
                    //     clearInterval(this.timer)
                    //     this.$router.push({ path: '/myDimension'})
                    // }
                }
            });
        },
        goBack(){ 
            clearInterval(this.timer)
            this.$router.go(-1)
        },
        initAudio() {
            // 初始化Audio对象并设置音频源
            // this.audio1 = new Audio(this.audioSrc);
            try {

                this.audio1.play(); // 播放音频
            } catch (error) {
                console.error('Error playing audio:', error);
            }
        },
        // 处理文件选择
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
                // 生成临时 URL 用于预览
                this.imageUrl = URL.createObjectURL(file);
            }
        },
        uploadImage(){
            // let params = new FormData();
            // params.append("file", this.imageUrl);
            // uploadImg(params).then((res) => {
            //     console.log('上传成功: ', res.data) 
            // });

            const formData = new FormData();
            formData.append('file', this.selectedFile); // 'file' 是后端接口接收文件的字段名

            // 使用 axios 发送请求
            axios.post('https://yiqingup.147.baiyunkj.cn/api/index/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // 设置请求头
                },
                // header: {
                // "cloud-app-id": "612072807591-yiqing"
                // },
            })
            .then((response) => {
                alert('上传成功: ' + JSON.stringify(response.data))
                // this.uploadResult = '上传成功: ' + JSON.stringify(response.data);
                })
                .catch((error) => {
                alert('上传失败: ' + error.message)
            // this.uploadResult = '上传失败: ' + error.message;
            });
        },
    },
    created() {
        // this.audio1 = new Audio('https://c.weimobwmc.com/ol-6NoGC/d8f5d4f8f5c444e48d37d44f6255905e.mp3'); // 确保路径正确
        //     this.audio2 = new Audio('https://c.weimobwmc.com/ol-6NoGC/91bcc83a96774965b6efc615d8d36d95.mp3'); // 确保路径正确
        //     this.audio3 = new Audio('https://c.weimobwmc.com/ol-6NoGC/48fe0b5ee13a4fbf97a14f40be236036.mp3'); // 确保路径正确
        //     this.audio4 = new Audio('https://c.weimobwmc.com/ol-6NoGC/7c065a56d7db4a8384031c9d982c1e5a.mp3'); // 确保路径正确
        console.log('aiFitter mounted',JSON.parse(localStorage.getItem('userInfo')))
    },
    // 以下函数会在组件实例被销��之前调用
    // 例如这个函数就会在组件挂载完成后被调用
    mounted() {
        this.audio1 = new Howl({
            src: ['https://c.weimobwmc.com/ol-6NoGC/d8f5d4f8f5c444e48d37d44f6255905e.mp3'],
            autoplay: true,
            volume: 1.0,
        });
        this.audio2 = new Howl({
            src: ['https://c.weimobwmc.com/ol-6NoGC/ce153e0542b54419bbd03e6ab44b9358.mp3'],
            volume: 1.0
        });
        this.audio3 = new Howl({
            src: ['https://c.weimobwmc.com/ol-6NoGC/48fe0b5ee13a4fbf97a14f40be236036.mp3'],
            volume: 1.0
        });
        this.audio4 = new Howl({
            src: ['https://c.weimobwmc.com/ol-6NoGC/7c065a56d7db4a8384031c9d982c1e5a.mp3'],
            volume: 1.0
        });
        // console.log(this.audio1)
        // this.audio1.play()
        // setTimeout(()=>{
        //     this.$router.push({ name: 'videoLoad',params:{status:'dimension'} });
        // },3000)
        // setTimeout(() => {
        //     this.audio1.pause()
        // }, 2000);
        // 组件挂载时初始化Audio对象
        // this.initAudio();
        // let that = this;
        // document.addEventListener('DOMContentLoaded', function () {
        // const hiddenButton = document.createElement('button');
        // hiddenButton.style.display = 'none';
        // document.body.appendChild(hiddenButton);
        // hiddenButton.click();
        // hiddenButton.remove();
        // // 在这里进行JSMpeg的初始化操作
        
        // });

    },
    beforeDestroy() {
        // 组件销��时关闭 Audio 对象的音频
        this.audio1.pause();
        this.audio2.pause();
        this.audio3.pause();
        this.audio4.pause();
    }
}
</script>
<style src="./index.less" scoped lang="less"></style>